import { assert, log } from '../../../app/logger.js';
import { EventedGoogleMaps } from './evented_googlemaps.js';

/**
 * GoogleMaps layer.
 */
class LayerGoogleMaps extends EventedGoogleMaps {
  get visible() {
    return this.native.getVisible();
  }

  set visible(v) {
    this.native.setVisible(v);
  }

  setStyles(options) {
    this.native.setOptions(this.getNativeOptions(options));
  }

  get attached() {
    return this.native.getMap();
  }

  attachTo(map) {
    if (this.attached) {
      return;
    }

    log(`[map:googlemaps] attach '${this.name}' to the map`);
    assert(map, `[map:googlemaps] '${this.name}' attach to the map: no map`);
    assert(
      map.native,
      `[map:googlemaps] '${this.name}' attach to the map: no googlemaps map`
    );
    this.#nativeMap = map.native;
    this.native.setMap(this.#nativeMap);
  }

  deattach() {
    if (!this.attached) {
      return;
    }

    log(`[map:googlemaps] deattach '${this.name}' from the map`);
    this.native.setMap(null);
    this.#nativeMap = null;
  }

  // Protected

  get nativeMap() {
    return this.#nativeMap;
  }

  static nativeOptionsMapper = {
    clickable: 'clickable',
    map: map => map.native,
    visible: 'visible',
  };

  #nativeMap;
}

export { LayerGoogleMaps };
